<template>
	<div class="chargeStandardDispose ">
		<div class="itemTitleBox disStart">
			<span class="title">社区充电收费标准</span>
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="myinputBox">
					<el-input clearable v-model="searchObj.search" placeholder="请输入社区名称"></el-input>
					<!-- <el-select clearable v-model="searchObj.search" filterable remote reserve-keyword
						placeholder="请输入社区关键词" :remote-method="remoteMethod" @change="changeSelect">
						<el-option v-for="item in restaurants" :key="item.communityName" :label="item.communityName"
							:value="item.communityName">
						</el-option>
					</el-select> -->
				</div>
				<div class="myinputBox">
					<el-select clearable v-model="searchObj.equipmentRunStatus" slot="prepend" placeholder="请选择运营状态">
						<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
							:value="item.value"></el-option>
					</el-select>
				</div>
				<el-button type="success" @click="toSearch">查询</el-button>
			</div>

		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-loading="loading">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号" width="60">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="社区名称">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityTypeName" label="社区类型">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="areaCode" label="地区" width="150">
							<template slot-scope="scope">
								{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.areaName}}
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityAddress" label="具体地址" width="150">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNumber" label="设备数量" width="80">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentServiceProvider" label="运营商">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="billingType" label="计费方式">
							<template slot-scope="scope">
								{{scope.row.billingType == 0 ? '功率计费':'电量计费'}}
							</template>
						</el-table-column>

						<el-table-column prop="operate" label="操作" width="60">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="itemClick(scope.row)">配置</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange($event,1)">
					</el-pagination>
				</div>
			</div>

		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible1" width="90%">
			<div style="margin-left: 25px;margin-top: 10px;">
				<span class="title" :class="{active:active==0}" @click="changeList(0)">功率计费配置</span>
				<span class="linBox">|</span>
				<span class="title" :class="{active:active==1}" @click="changeList(1)">电量计费配置</span>
			</div>
			<div style="height: 100%;width: 100%;" v-loading="loading" v-if="active==0">
				<div class="dialogBox">
					<div class="tabBox disBetween">
						<el-radio-group v-model="tabPosition">
							<el-radio-button v-for="(item,inx) in tabList" :key="inx"
								:label="inx">{{item.minPower}}~{{item.maxPower}}W</el-radio-button>
						</el-radio-group>
						<span class="powermanage" @click="powermanage">功率管理</span>
					</div>
					<div class="disStart" v-for="(item,inx) in itemObj.diaList" :key="inx">
						<div class="nameBox">配置{{inx+1}}</div>
						<div class="numItem disStart">
							<div class="lableBox">充电金额：</div>
							<div class="inputBox">
								<el-input v-model="item.rechargeMoney" type="Number" placeholder=""></el-input>
							</div>
							<div class="unitBox">元</div>
						</div>
						<div class="numItem disStart">
							<div class="lableBox">充电时长：</div>
							<div class="inputBox">
								<el-input v-model="item.rechargeTime" type="Number" placeholder=""></el-input>
							</div>
							<div class="unitBox">分钟</div>
						</div>

						<!-- <div class="btnBox disStart">
							<span class="delIcon" @click="btnClick1(item,inx,1)"></span>
							<span class="addIcon" v-if="inx==itemObj.diaList.length-1"
								@click="btnClick1(item,inx,2)"></span>
						</div> -->
					</div>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button @click="dialogVisible1 = false">取 消</el-button>
					<el-button type="primary" @click="saveBtn1">确 定</el-button>
				</div>
			</div>
			<div style="height: 100%;width: 100%;" v-loading="loading" v-if="active==1">
				<div class="period-config-container">
					<!-- 顶部图例 -->
					<div class="tab-header">
						<span v-for="tab in tabs" :key="tab.key" class="tab-item"
							:class="{ active: activeTab === tab.key }" @click="switchTab(tab.key)">
							<i class="dot" :style="{ backgroundColor: tab.color }"></i>
							{{ tab.label }}
						</span>
					</div>

					<!-- 操作栏 -->
					<div class="action-bar">
						<el-button type="primary" size="small" icon="el-icon-plus" @click="addRow">新增时段</el-button>
					</div>

					<!-- 表格区域 -->
					<el-table :data="currentList" border style="width: 100%" class="config-table">
						<el-table-column label="开始时间" width="220">
							<template slot-scope="scope">
								<el-time-picker v-model="scope.row.startTime" placeholder="选择时间" format="HH:mm"
									value-format="HH:mm" style="width: 100%"></el-time-picker>
							</template>
						</el-table-column>

						<el-table-column label="结束时间" width="220">
							<template slot-scope="scope">
								<el-time-picker v-model="scope.row.endTime" placeholder="选择时间" format="HH:mm"
									value-format="HH:mm" style="width: 100%"></el-time-picker>
							</template>
						</el-table-column>

						<el-table-column label="电价(元/度)">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.price" :min="0" :precision="2" :step="0.1"
									controls-position="right" style="width: 100%"></el-input-number>
							</template>
						</el-table-column>

						<el-table-column label="操作" width="100" align="center">
							<template slot-scope="scope">
								<el-button type="text" class="delete-btn"
									@click="deleteRow(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>

					<!-- 底部按钮 -->
					<div class="footer-actions">
						<el-button type="primary" @click="handleSave">保存</el-button>
						<el-button @click="handleReset">重置</el-button>
					</div>

				</div>
			</div>

		</el-dialog>
		<el-dialog title="功率管理" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogVisible2"
			width="70%">
			<div class="dialogBox">
				<div class="disStart" v-for="(item,inx) in MytabList" :key="inx">
					<div class="numItem disStart">
						<div class="inputBox">
							<el-input @input="numberChange(item.minPower,1000,inx,1)" disabled v-model="item.minPower"
								type="Number" placeholder=""></el-input>
						</div>
						<div class="unitBox">~</div>
					</div>
					<div class="numItem disStart">
						<div class="inputBox">
							<el-input @input="numberChange(item.maxPower,1000,inx,2)" v-model="item.maxPower"
								type="Number" placeholder="" @change="changeEnd($event,inx)"></el-input>
						</div>
						<div class="unitBox">W</div>
					</div>
					<div class="btnBox disStart">
						<span class="delIcon" v-if="inx!=0  && inx==MytabList.length-1"
							@click="btnClick2(item,inx,1)"></span>
						<span class="addIcon" v-if="inx==MytabList.length-1 && MytabList.length<10"
							@click="btnClick2(item,inx,2)"></span>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer diabtnBox disAround">
				<!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
				<el-button type="primary" @click="saveBtn2">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	var token = localStorage.getItem('token')
	export default {
		name: "chargeStandardDispose",
		components: {},
		props: {
			disposeList: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				active: 0,
				str: "设备",
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				searchObj: {
					search: "",
					pageNo: 1, //当前页
					pageSize: 10, //当
					provinceCode: "", //省级编号
					cityCode: "", //市级编号
					areaCode: "" //区级编号
				},
				operateStatusList: [{
						text: "未投用",
						value: 1
					},
					{
						text: "运营中",
						value: 2
					},
					{
						text: "已拆除",
						value: 3
					},
				],
				tableData: [{
					communityEquipmentNo: "我是社区1"
				}],
				NOfalse: false,
				dialogTitle: "充电金额配置",
				dialogVisible1: false,
				dialogVisible2: false,
				loading: false,
				restaurants: [],
				itemObj: {
					diaList: [],
					itemInfo: {}
				},
				tabList: [],
				MytabList: [],
				tabPosition: 0,

				// 当前激活的 Tab
				activeTab: 'peak',
				// Tab 定义
				tabs: [{
						label: '高峰时段',
						key: 'peak',
						color: '#ff4d4f'
					}, // 红色
					{
						label: '平段时段',
						key: 'flat',
						color: '#faad14'
					}, // 黄色
					{
						label: '低谷时段',
						key: 'valley',
						color: '#52c41a'
					} // 绿色
				],

				// 核心数据：按类型隔离存储
				formData: {
					peak: [{
						startTime: '',
						endTime: '',
						price: 0.00,
						gearType: 0
					}],
					flat: [{
						startTime: '',
						endTime: '',
						price: 0.00,
						gearType: 1
					}],
					valley: [{
						startTime: '',
						endTime: '',
						price: 0.00,
						gearType: 2
					}]
				},

			}
		},
		watch: {
			tabPosition(n) {
				console.log(n)
				if (this.tabList[n].communityBaseSetList && this.tabList[n].communityBaseSetList.length > 0) {
					this.$set(this.itemObj, "diaList", this.tabList[n].communityBaseSetList)
				} else {
					this.$set(this.itemObj, "diaList", [{
						minPower: "",
						maxPower: ""
					}])
				}
			},
		},
		mounted() {
			this.getData()
		},
		computed: {
			// 计算属性：根据当前 Tab 返回对应的数据数组
			currentList() {
				return this.formData[this.activeTab];
			}
		},
		methods: {
			changeList(n) {
				this.active = n
				// this.$nextTick(() => {
				// 	this.getbillType()
				// })
			},
			// 切换 Tab
			switchTab(key) {
				this.activeTab = key;
			},

			// 新增行
			addRow() {
				const newRow = {
					startTime: '',
					endTime: '',
					price: 0.00,
					gearType: this.getGearTypeByTab(this.activeTab)
				};
				this.formData[this.activeTab].push(newRow);
			},

			// 删除行
			deleteRow(index) {
				this.formData[this.activeTab].splice(index, 1);
			},
			/**
			 * 辅助函数：根据 Tab 名获取 gearType
			 */
			getGearTypeByTab(tabName) {
				if (tabName === 'peak') return 0;
				if (tabName === 'flat') return 1;
				if (tabName === 'valley') return 2;
				return 0;
			},
			// 重置逻辑
			handleReset() {
				this.$confirm('确定要清空所有配置吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 重置所有数组为默认空行
					['peak', 'flat', 'valley'].forEach(key => {
						this.dataMap[key] = [{
							startTime: '',
							endTime: '',
							price: 0.00
						}];
					});
					this.activeTab = 'peak';
				}).catch(() => {});
				this.addRow(); // 重置后保留一行
			},
			// 保存逻辑
			handleSave() {
				// 这里可以将三个数组整合发给后端，或者分别发送
				// const payload = {
				// 	peakList: this.dataMap.peak,
				// 	flatList: this.dataMap.flat,
				// 	valleyList: this.dataMap.valley
				// };
				// console.log('提交给后端的数据:', payload);

				// 1. 简单校验（可选）
				if (!this.validateData()) return;

				// 2. 将分组数据转换为后端需要的扁平数组格式
				const submitData = this.formatForBackend();

				console.log("传给后端的数据结构：", submitData);
				let obj = {
					communityId: this.itemObj.communityId,
					periodList: submitData
				}

				this.$api.saveElectricPricePeriod(obj).then(res=>{
					console.log(res);
					if(res.returnCode == 200){
						this.$message.success('保存成功');
						this.dialogVisible1 = false
					}else{
						this.$message.success('保存失败');
					}
				})

				// this.$message.success('保存成功，请查看控制台输出');
			},

			// 【重点】将 {peak:[], flat:[], valley:[]} 转换为 [{...gearType:0}, {...gearType:1}]
			formatForBackend() {
				const result = [];

				// 处理高峰 (gearType: 0)
				if (this.formData.peak.length > 0) {
					this.formData.peak.forEach(item => {
						result.push({
							startTime: item.startTime,
							endTime: item.endTime,
							price: item.price,
							gearType: 0
						});
					});
				}

				// 处理平段 (gearType: 1)
				if (this.formData.flat.length > 0) {
					this.formData.flat.forEach(item => {
						result.push({
							startTime: item.startTime,
							endTime: item.endTime,
							price: item.price,
							gearType: 1
						});
					});
				}

				// 处理低谷 (gearType: 2)
				if (this.formData.valley.length > 0) {
					this.formData.valley.forEach(item => {
						result.push({
							startTime: item.startTime,
							endTime: item.endTime,
							price: item.price,
							gearType: 2
						});
					});
				}

				return result;
			},
			// 简单校验逻辑
			validateData() {
				let isValid = true;
				['peak', 'flat', 'valley'].forEach(type => {
					this.formData[type].forEach((row, index) => {
						if (!row.startTime || !row.endTime) {
							this.$message.error(`${type} 第 ${index+1} 行的时间未填写完整`);
							isValid = false;
						}
					});
				});
				return isValid;
			},

			getbillType() {
				let communityId = this.itemObj.communityId
				console.log(communityId);
				// this.$api.listElectricPricePeriod(communityId).then(res => {
				// 	console.log(res);
				// 	if (res.returnCode == 200) {
				// 		this.formData = this.loadDataFromBackend(res.data)
				// 	}
				// })
			},

			// ================= 补充：如果后端返回扁平数据，如何回显 =================
			// 假设 res.data 是后端返回的数组 [{startTime.., gearType:0}, ...]
			loadDataFromBackend(apiData) {
				// 初始化一个新的临时对象
				const newData = {
					peak: [],
					flat: [],
					valley: []
				};

				if (!apiData || apiData.length === 0) return newData;

				apiData.forEach(item => {
					// 深拷贝一下，防止修改新数据影响原数据
					const row = {
						...item
					};

					// 根据 gearType 分发
					if (item.gearType === 0) {
						newData.peak.push(row);
					} else if (item.gearType === 1) {
						newData.flat.push(row);
					} else if (item.gearType === 2) {
						newData.valley.push(row);
					}
				});

				// 关键：必须把处理好的数据返回出去
				return newData;
			},


			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			getData(obj) {
				this.loading = true
				console.log(this.searchObj, 222222)
				this.$api.listCommunityInfo2(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					} else {
						this.loading = false
						this.$message({
							message: res.returnMessage || "请求异常",
							type: 'error'
						});
					}
				})
			},
			changeSelect(n) {

			},
			changeEnd(e, inx) {
				if (inx <= 4) {
					if (this.MytabList[inx + 1]) {
						this.$set(this.MytabList[inx + 1], "minPower", e)
					}

				}
			},
			numberChange(val, maxNum, n, type) {
				//转换数字类型
				let num = Number(val)
				if (num < 0) {
					if (type == 1) {
						this.$set(this.MytabList[n], "minPower", 0)
					} else {
						this.$set(this.MytabList[n], "maxPower", 0)
					}
				}
				if (num > 2000) {
					if (type == 1) {
						this.$set(this.MytabList[n], "minPower", 2000)
					} else {
						this.$set(this.MytabList[n], "maxPower", 2000)
					}
				}
			},
			powermanage() {
				if (this.tabList.length > 0) {
					this.MytabList = this.tabList
				} else {
					this.MytabList = [{
						minPower: 0,
						maxPower: ""
					}]
				}
				this.dialogVisible2 = true
			},
			handleSelect(item) {

				this.$set(this.creatObj, "equipmentServiceProvider", item.value)

			},
			itemClick(item) {
				let that = this
				this.tabPosition = 0
				this.$api.listRechargeBasicSetByCommunityId({
					communityId: item.communityId
				}).then((res) => {
					if (res.returnCode == 200) {

						this.$set(this.itemObj, "communityId", item.communityId)
						if (res.obj && res.obj.length > 0) {
							for (let k of res.obj) {
								for (let j of k.communityBaseSetList) {
									this.$set(j, "rechargeTime", j.rechargeTime * 60)
								}
							}
							this.$set(this, "tabList", res.obj)
							this.$set(this.itemObj, "diaList", res.obj[0].communityBaseSetList)
						} else {
							this.$set(this, "tabList", JSON.parse(JSON.stringify(this.disposeList)))
							this.$set(this.itemObj, "diaList", JSON.parse(JSON.stringify(this.disposeList))[0]
								.communityBaseSetList)
						}
					}
				})
				this.$api.listElectricPricePeriod({
					communityId: item.communityId
				}).then(res => {
					console.log(res);
					if (res.returnCode == 200) {
						this.formData = this.loadDataFromBackend(res.obj)
					}
				})
				this.dialogTitle = "充电金额配置(" + item.communityName + ")"
				this.dialogVisible1 = true




			},
			saveBtn2() {
				for (let k of this.MytabList) {
					if (k.maxPower) {
						if (Number(k.maxPower) > Number(k.minPower)) {

						} else {
							this.$message({
								type: "warning",
								message: '请输入正确功率范围！'
							});
							return false
						}
					} else {
						this.$message({
							type: "warning",
							message: '请输入正确功率范围！'
						});
						return false
					}
				}
				this.$nextTick(() => {
					this.$set(this, "tabList", this.MytabList)
					this.$message({
						type: "success",
						message: '配置成功!'
					});
					this.tabPosition = 0
					this.dialogVisible2 = false
				})
			},
			saveBtn1() {
				let newArr = this.tabList
				for (let j of newArr) {
					if (j.communityBaseSetList && j.communityBaseSetList.length > 0) {
						for (let k of j.communityBaseSetList) {
							if (k.rechargeTime === 0 || k.rechargeMoney === 0) {
								this.$message({
									type: 'warning',
									message: '充电时长和充电金额不能为0!'
								});
								return false
							}
							if (k.rechargeTime % 15 != 0) {
								this.$message({
									type: 'warning',
									message: '充电时长请输入15的倍数值!'
								});
								return false
							}
							if (!(k.rechargeTime) || !(k.rechargeMoney)) {
								this.$message({
									type: 'warning',
									message: '充电时长和充电金额不能为空!'
								});
								return false
							}
							k.rechargeTime = parseFloat((k.rechargeTime / 60).toFixed(2))
						}
					} else {
						this.$message({
							type: 'warning',
							message: '充电时长和充电金额不能为空!'
						});
						return false
					}

				}
				let obj = {
					communityId: this.itemObj.communityId,
					rechargePowerSetList: newArr
				}
				this.$api.updateRechargeBasicSetByCommunityId(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$message({
							type: "success",
							message: '配置成功!'
						});
						this.dialogVisible1 = false
					}
				})
			},
			btnClick2(item, inx, n) {
				if (n == 1) {

					if (this.MytabList.length == 1) {
						this.$message({
							type: 'warning',
							message: '最少保留一个功率区间!'
						});
						return false
					}
					let that = this
					this.$confirm('是否确认删除该功率区间?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.MytabList.splice(inx, 1)
						that.$message({
							type: 'success',
							message: '删除成功!'
						});


					}).catch(() => {

					});
				} else if (n == 2) {
					if (this.MytabList.length == 0) {
						this.MytabList.push({
							minPower: 0,
							maxPower: '',
							communityBaseSetList: [{
								rechargeMoney: "",
								rechargeTime: ""
							}]
						})
					} else {
						for (let k of this.MytabList) {
							if (k.maxPower) {
								if (Number(k.maxPower) > Number(k.minPower)) {

								} else {
									this.$message({
										type: "warning",
										message: '请输入正确功率范围！'
									});
									return false
								}
							} else {
								this.$message({
									type: "warning",
									message: '请输入正确功率范围！'
								});
								return false
							}
						}
						this.$nextTick(() => {
							this.$set(this.MytabList, [this.MytabList.length], {
								minPower: this.MytabList[this.MytabList.length - 1].maxPower,
								maxPower: "",
								communityBaseSetList: [{
									rechargeMoney: "",
									rechargeTime: ""
								}]
							})
						})
					}

				}
			},
			btnClick1(item, inx, n) {
				if (n == 1) {
					if (this.itemObj.diaList.length == 1) {
						this.$message({
							type: 'warning',
							message: '最少保存一个标准配置!'
						});
						return false
					}
					let that = this
					this.$confirm('是否确认删除该配置项?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.itemObj.diaList.splice(inx, 1)
						that.$message({
							type: 'success',
							message: '删除成功!'
						});


					}).catch(() => {

					});
				} else {

					this.itemObj.diaList.push({
						rechargeMoney: "",
						rechargeTime: ""
					})
				}
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData({})
			},
			// 搜索
			toSearch() {
				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.getData({})
			},

		}
	}
</script>

<style lang="scss" scoped>
	@import "./chargeStandardDispose.scss"
</style>